import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Button } from '../Button';
import { isIdentityFailurePermanent } from '../../../utils/utilsUser';
import { UserType } from '../../../utils/utilTypes';
import { stripe } from '../../../lib/stripe';
import { CREATE_IDENTITY_VERIFICATION_MUTATION } from '../../../graphql/stripe/identity/createIdentityVerificationSession';
import { useAuth } from '../../../lib/auth';

type Props = {
  currentUser: UserType;
};

export const IdentityFailedPopup = ({ currentUser }: Props) => {
  const { t } = useTranslation();
  const { getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [createVerificationSession] = useMutation(CREATE_IDENTITY_VERIFICATION_MUTATION);

  const isPermanent = isIdentityFailurePermanent(currentUser);
  const errorCode = currentUser.stripeVerificationSession?.lastError;
  const errorMessage = errorCode
    ? t(`identityFailedPopup.errors.${errorCode}`, { defaultValue: t('identityFailedPopup.body') })
    : t('identityFailedPopup.body');

  const handleRetry = async () => {
    setLoading(true);
    try {
      const { data: { createVerificationSession: client_secret } } = await createVerificationSession();
      const result = await stripe?.verifyIdentity(client_secret);
      if (result?.error) console.log('error', result.error);
    } catch (err) {
      console.log(err);
    } finally {
      await getCurrentUser();
      setLoading(false);
    }
  };

  return (
    <div className="absolute bg-white z-status-popup left-[36px] right-[36px] top-[32px] shadow-lg flex flex-col p-6">
      <div className="text-lg text-center text-danger font-bold">
        {t('identityFailedPopup.title')}
      </div>
      <div className="my-4 text-sm text-center text-gray-600">
        {isPermanent ? t('identityFailedPopup.bodyPermanent') : errorMessage}
      </div>
      {isPermanent ? (
        <a
          href="mailto:contact@rastel.io"
          className="text-sm text-center text-primary underline mt-1"
        >
          {t('identityFailedPopup.contactSupport')}
        </a>
      ) : (
        <Button className="text-sm" type="primary" onClick={handleRetry} disabled={loading}>
          {t('identityFailedPopup.retry')}
        </Button>
      )}
    </div>
  );
};
